import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../resource/kgvl1.png';
import kgvmitr from '../resource/kgvmitr1.png';
import footerbgpic from '../resource/footerbgpic.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faInstagram,
	faTwitter,
	faLinkedinIn,
	faFacebook,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

export const Footer = () => {
	return (
		<footer className="relative bg-slate-900 text-gray-300 overflow-hidden">
			{/* Background Image with Overlay */}
			<div
				className="absolute inset-0 opacity-20"
				style={{
					backgroundImage: `url(${footerbgpic})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
			></div>
			<div className="absolute inset-0 bg-gradient-to-br from-slate-900/95 via-slate-800/95 to-emerald-900/90"></div>

			{/* Mascot Image */}
			<img
				src={kgvmitr}
				alt="KGVL Mascot"
				className="hidden lg:block absolute bottom-0 right-8 w-40 h-auto opacity-80 hover:opacity-100 transition-opacity z-10"
			/>

			<div className="relative z-20 max-w-7xl mx-auto px-6 py-10">
				{/* Main Footer Content */}
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 mb-8">

					{/* Column 1: Logo + Company Info */}
					<div className="lg:col-span-4">
						<div className="flex items-center gap-3 mb-4">
							<img
								src={logo}
								alt="KGV Logo"
								className="w-12 h-12 rounded-full ring-2 ring-emerald-400/30"
							/>
							<h3 className="text-lg font-bold text-white">
								Karishma Global Ventures
							</h3>
						</div>

						<div className="flex items-start gap-2 text-sm text-gray-400">
							<FontAwesomeIcon icon={faMapMarkerAlt} className="text-emerald-400 mt-1 text-xs flex-shrink-0" />
							<p className="leading-relaxed">
								609, Tower II, Pearls Omaxe, Netaji Subash Place,
								Pitampura, New Delhi - 110034, India
							</p>
						</div>
					</div>

					{/* Column 2: Quick Links */}
					<div className="lg:col-span-2">
						<h4 className="text-white font-semibold text-sm mb-3 uppercase tracking-wider">
							Quick Links
						</h4>
						<ul className="space-y-2 text-sm">
							<li>
								<Link to="/" className="text-gray-400 hover:text-emerald-400 transition-colors inline-block">
									Home
								</Link>
							</li>
							<li>
								<Link to="/distribution" className="text-gray-400 hover:text-emerald-400 transition-colors inline-block">
									Distribution
								</Link>
							</li>
							<li>
								<Link to="/event" className="text-gray-400 hover:text-emerald-400 transition-colors inline-block">
									Events
								</Link>
							</li>
						</ul>
					</div>

					{/* Column 3: Products/Bikes */}
					<div className="lg:col-span-2">
						<h4 className="text-white font-semibold text-sm mb-3 uppercase tracking-wider">
							Bikes
						</h4>
						<ul className="space-y-2 text-sm">
							<li>
								<Link to="/KgvbikeOrder" className="text-gray-400 hover:text-emerald-400 transition-colors inline-block">
									Buy KGV BIKE
								</Link>
							</li>
							<li>
								<Link to="/KgvkitOrder" className="text-gray-400 hover:text-emerald-400 transition-colors inline-block">
									Buy KGV KIT
								</Link>
							</li>
							<li>
								<Link to="/rentkgvbike" className="text-gray-400 hover:text-emerald-400 transition-colors inline-block">
									Rent KGV BIKE
								</Link>
							</li>
						</ul>
					</div>

					{/* Column 4: Company */}
					<div className="lg:col-span-2">
						<h4 className="text-white font-semibold text-sm mb-3 uppercase tracking-wider">
							Company
						</h4>
						<ul className="space-y-2 text-sm">
							<li>
								<Link to="/about" className="text-gray-400 hover:text-emerald-400 transition-colors inline-block">
									About Us
								</Link>
							</li>
							<li>
								<Link to="/Privacypolicy" className="text-gray-400 hover:text-emerald-400 transition-colors inline-block">
									Privacy Policy
								</Link>
							</li>
							<li>
								<Link to="/contactUs" className="text-gray-400 hover:text-emerald-400 transition-colors inline-block">
									Contact Us
								</Link>
							</li>
						</ul>
					</div>

					{/* Column 5: Contact */}
					<div className="lg:col-span-2">
						<h4 className="text-white font-semibold text-sm mb-3 uppercase tracking-wider">
							Get In Touch
						</h4>
						<div className="space-y-2 text-sm">
							<a href="mailto:team@kgvl.co.in" className="flex items-center gap-2 text-gray-400 hover:text-emerald-400 transition-colors">
								<FontAwesomeIcon icon={faEnvelope} className="text-xs" />
								<span className="truncate">team@kgvl.co.in</span>
							</a>
							<a href="mailto:sid@kgvl.co.in" className="flex items-center gap-2 text-gray-400 hover:text-emerald-400 transition-colors">
								<FontAwesomeIcon icon={faEnvelope} className="text-xs" />
								<span className="truncate">sid@kgvl.co.in</span>
							</a>
							<a
  href="tel:+919661829944"
  className="flex items-start gap-2 text-gray-400 hover:text-emerald-400 transition-colors"
>
  <FontAwesomeIcon icon={faPhone} className="text-xs mt-1" />

  <div className="flex flex-col">
    <span>+91 8447961976</span>
    <span>+91 9559986872</span>
  </div>
</a>

						</div>
					</div>
				</div>

				{/* Bottom Bar */}
				<div className="border-t border-gray-700/50 pt-6">
					<div className="flex flex-col md:flex-row justify-between items-center gap-4">
						<p className="text-sm text-gray-400">
							© {new Date().getFullYear()}{" "}
							<span className="text-white font-semibold">KGV HYBRID GREEN MOBILITY PRIVATE LIMITED.</span>.
							All rights reserved.
						</p>


						{/* Social Media Icons */}
						<div className="flex gap-3">
							<a
								href="https://www.facebook.com/share/1EFtxnRMuL/"
								className="w-9 h-9 rounded-full bg-slate-800 hover:bg-emerald-600 flex items-center justify-center transition-all duration-300 hover:scale-110"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Facebook"
							>
								<FontAwesomeIcon icon={faFacebook} className="text-sm" />
							</a>
							<a
								href="https://www.instagram.com/kgvllp?igsh=MWZwbnZxbG4xZnZz"
								className="w-9 h-9 rounded-full bg-slate-800 hover:bg-pink-600 flex items-center justify-center transition-all duration-300 hover:scale-110"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Instagram"
							>
								<FontAwesomeIcon icon={faInstagram} className="text-sm" />
							</a>
							<a
								href="https://x.com/KGVllp?t=ecvFy4j65dHiRpRzpOWGtg&s=09"
								className="w-9 h-9 rounded-full bg-slate-800 hover:bg-blue-400 flex items-center justify-center transition-all duration-300 hover:scale-110"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Twitter"
							>
								<FontAwesomeIcon icon={faTwitter} className="text-sm" />
							</a>
							<a
								href="https://www.linkedin.com/company/karishmaglobal/"
								className="w-9 h-9 rounded-full bg-slate-800 hover:bg-blue-700 flex items-center justify-center transition-all duration-300 hover:scale-110"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="LinkedIn"
							>
								<FontAwesomeIcon icon={faLinkedinIn} className="text-sm" />
							</a>

						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};